import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config/ApiConfig';
import DefaultModal from './DefaultModal';
import useDefaultModal from '../hooks/useDefaultModal';
import EntidadeSearchModal from './EntidadeSearchModal';

function VinculoModal({ show, onClose, onSuccess, vinculoData, usuario }) {
  const [vinculo, setVinculo] = useState({
    cnpj: '',
    idEntidade: '',
    cpf: '',
    tipo: '',
    situacao: 'ATIVO',
  });
  const [entidadeSelecionada, setEntidadeSelecionada] = useState(null);
  const [showEntidadeModal, setShowEntidadeModal] = useState(false);
  const token = localStorage.getItem('token');
  const { setDefaultModal, showDefaultModal } = useDefaultModal();

  useEffect(() => {
    if (show) {
      // Preencher formulário se estiver editando
      if (vinculoData) {
        setVinculo({
          cnpj: vinculoData.cnpj || '',
          idEntidade: vinculoData.idEntidade || '',
          cpf: vinculoData.cpf || '',
          tipo: vinculoData.tipo || '',
          situacao: vinculoData.situacao || 'ATIVO',
        });
        // Carregar entidade selecionada para exibição
        if (vinculoData.entidade) {
          setEntidadeSelecionada(vinculoData.entidade);
        }
      } else if (usuario) {
        // Novo vínculo
        setVinculo({
          cnpj: '',
          idEntidade: '',
          cpf: usuario.cpf || '',
          tipo: '',
          situacao: 'ATIVO',
        });
        setEntidadeSelecionada(null);
      }
    } else {
      // Limpar formulário quando fechar
      setVinculo({
        cnpj: '',
        idEntidade: '',
        cpf: '',
        tipo: '',
        situacao: 'ATIVO',
      });
      setEntidadeSelecionada(null);
    }
  }, [show, vinculoData, usuario]);

  const handleChange = e => {
    const { name, value } = e.target;
    setVinculo(prev => ({
      ...prev,
      [name]: value.toUpperCase(),
    }));
  };

  const handleEntidadeSelect = entidade => {
    setEntidadeSelecionada(entidade);
    setVinculo(prev => ({
      ...prev,
      cnpj: entidade.cnpj,
      idEntidade: entidade.idEntidade,
    }));
    setShowEntidadeModal(false);
  };

  const handleRemoveEntidade = () => {
    setEntidadeSelecionada(null);
    setVinculo(prev => ({
      ...prev,
      cnpj: '',
      idEntidade: '',
    }));
  };

  const validateFields = () => {
    if (!vinculo.idEntidade) {
      showDefaultModal('error', 'Selecione uma entidade!');
      return false;
    }
    if (!vinculo.tipo) {
      showDefaultModal('error', 'Selecione o tipo de vínculo!');
      return false;
    }
    return true;
  };

  const handleSubmit = e => {
    e.preventDefault();
    
    if (!validateFields()) {
      return;
    }

    axios
      .post(`${API_BASE_URL.VINCULO}/save`, vinculo, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(() => {
        if (onSuccess) {
          onSuccess();
        }
      })
      .catch(error => {
        console.error('Erro ao salvar vínculo:', error);
        showDefaultModal('error', 'Erro ao salvar o vínculo!');
      });
  };

  if (!show) return null;

  return (
    <>
      <div
        className="modal show d-block"
        tabIndex="-1"
        style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div
              className="modal-header text-white"
              style={{
                background:
                  'linear-gradient(45deg, rgb(7, 29, 65) 0%, rgba(29, 100, 216, 1) 100%)',
                padding: '0.5rem 1rem',
              }}
            >
              <h6 className="modal-title mb-0">
                <i className="bi bi-link-45deg me-2"></i>
                {vinculoData ? 'Editar Vínculo' : 'Novo Vínculo'}
              </h6>
              <button
                type="button"
                className="btn-close btn-close-white"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label small fw-semibold">
                    Cliente/Entidade <span className="text-danger">*</span>
                  </label>
                  {entidadeSelecionada ? (
                    <div className="d-flex align-items-center gap-2">
                      <div
                        className="form-control form-control-sm bg-light flex-grow-1"
                        style={{ cursor: 'default' }}
                      >
                        <div className="d-flex flex-column">
                          <strong>{entidadeSelecionada.nome}</strong>
                          <small className="text-muted">
                            CNPJ: {entidadeSelecionada.cnpj} | {entidadeSelecionada.logrCidade || entidadeSelecionada.municipio}/{entidadeSelecionada.logrUf || entidadeSelecionada.uf}
                          </small>
                        </div>
                      </div>
                      {!vinculoData && (
                        <button
                          type="button"
                          className="btn btn-outline-danger btn-sm"
                          onClick={handleRemoveEntidade}
                          title="Remover entidade selecionada"
                        >
                          <i className="bi bi-x-lg"></i>
                        </button>
                      )}
                    </div>
                  ) : (
                    <button
                      type="button"
                      className="btn btn-outline-primary btn-sm w-100"
                      onClick={() => setShowEntidadeModal(true)}
                      disabled={vinculoData}
                    >
                      <i className="bi bi-search me-1"></i>
                      Buscar Entidade
                    </button>
                  )}
                </div>

                <div className="mb-3">
                  <label className="form-label small fw-semibold">
                    Tipo de Vínculo <span className="text-danger">*</span>
                  </label>
                  <select
                    onChange={handleChange}
                    value={vinculo.tipo}
                    name="tipo"
                    className="form-select form-select-sm"
                    required
                  >
                    <option value="">Selecione...</option>
                    <option value="ADMIN">ADMINISTRADOR</option>
                    <option value="GEST">GESTOR</option>
                    <option value="USER">USUÁRIO</option>
                  </select>
                </div>

                <div className="d-flex justify-content-end gap-2 mt-4">
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm"
                    onClick={onClose}
                  >
                    <i className="bi bi-x-circle me-1"></i>
                    Cancelar
                  </button>
                  <button type="submit" className="btn btn-success btn-sm">
                    <i className="bi bi-check-lg me-1"></i>
                    Salvar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <DefaultModal {...setDefaultModal} />
      <EntidadeSearchModal
        show={showEntidadeModal}
        onClose={() => setShowEntidadeModal(false)}
        onSelect={handleEntidadeSelect}
      />
    </>
  );
}

export default VinculoModal;
